import ParameterErrors from '../errors/ParameterErrors';
const {throwNotProvided}=ParameterErrors;
export default class CurrencyConfiguration{
	constructor(props){
	const {currencyPrefix, currencySuffix} = props;
		if(currencyPrefix===undefined||currencyPrefix===null)
			throwNotProvided('currencyPrefix');
		if(currencySuffix===undefined||currencySuffix===null)
			throwNotProvided('currencySuffix');
		this._currencyPrefix = currencyPrefix;
		this._currencySuffix=currencySuffix;
	}
	get currencyPrefix(){
		return this._currencyPrefix;
	}
	get currencySuffix(){
		return this._currencySuffix;
	}
	static fromJSON (jObject){
		return new CurrencyConfiguration({currencyPrefix:jObject.currencyPrefix, currencySuffix:jObject.currencySuffix});
	}
}